import numbers from './numbers';
import video from './video';
import timeline from './timeline';

const initialize = () => {

    numbers.initialize();
    video.initialize();
    timeline.initialize();
};

export default {
    initialize,
};

